// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FbiHfbh3Y7U0cfSlQjQN{text-decoration:none}.jPgavhpfjjU6QssznvW6{align-items:flex-start;margin-top:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `FbiHfbh3Y7U0cfSlQjQN`,
	"declaration": `jPgavhpfjjU6QssznvW6`
};
export default ___CSS_LOADER_EXPORT___;
